import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.scss'],
})
export class EmailConfigurationComponent extends BaseCtl {
  appId: number = 0;

  // Holds current form data (for add/edit)
  emailConfigForm: any = {
    data: {
      smtpHost: '',
      smtpSecurity: '',
      smtpAuthType: '',
      smtpUser: '',
      smtpPass: '',
      smtpSessionLimit: 1,
    },
  };

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    // pass endpoint + required services to BaseListCtl
    super('endpoint.applicationconfiguration', locator, route);

    locator.config
      .getProperty('endpoint.applicationconfiguration')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });

    let _self = this;
    _self.appId = Number(this.route.snapshot.paramMap.get('appId'));

    console.log('>>>>>>>>>>>', _self.appId);
    _self.form.searchParams['appId'] = _self.appId;
    _self.search();
    _self.get(_self.appId);

    // _self.form.searchParams['appId'] = _self.applicationId;

    locator.getPathVariable(route, function (params: any) {
      _self.form.searchParams['appId'] = params['appId'];
    });

     _self.getEmailConfig();
        }

  saveSMTPConfig() {
    let _self = this;

    console.log('this is in method : ', _self.appId);
    _self.emailConfigForm.data['appId'] = _self.appId;
    console.log('this is in method : ', _self.emailConfigForm.data['appId']);

    console.log();

    let url =
      _self.locator.config.get('endpoint.applicationconfiguration') +
      '/emailconfiguration';

    console.log('Saving SMTP Config with payload:', _self.emailConfigForm.data);
    console.log('url : ' + url);

    _self.locator.http.post(
      url,
      _self.emailConfigForm.data,
      function (res: any, error: any) {
        if (error) {
          console.error('Error while saving SMTP config:', error);
          _self.form.error = true;
          _self.form.message = 'Failed to save SMTP Configuration!';
          return;
        }

        console.log('Response:', res);

        _self.form.error = !res.success;
        _self.form.message =
          res.message ||
          res.result?.message || // take top-level message first
          (res.success
            ? 'SMTP Configuration saved successfully!'
            : 'Failed to save!');

        if (res.success) {
          console.log('SMTP Config saved:', res);

          // Reset AFTER showing the message
          setTimeout(() => {
            _self.resetForm();
            _self.clearMessage(_self.form);
          }, 5000);
        } else {
          _self.form.inputerror = res.result?.inputerror || {};
        }
      },
    );
  }

  getEmailConfig() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.applicationconfiguration')
      .then((property: string) => {
        let url =
          _self.locator.config.get('endpoint.applicationconfiguration') +
          '/getemailconfiguration/' +
          _self.appId;

        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }

          const result = res.result?.data;
          if (!result) {
            console.error('No data returned for report');
            return;
          }

          // Prefill form
          // ✅ Fill the form data completely
          _self.emailConfigForm.data = {
            smtpHost: result.smtpHost || '',
            smtpSecurity: result.smtpSecurity || '',
            smtpAuthType: result.smtpAuthType || '',
            smtpUser: result.smtpUser || '',
            smtpPass: result.smtpPass || '',
            smtpSessionLimit: result.smtpSessionLimit || 1,
          };
        });
      });
  }
  hidePassword = true;
}
